import { render, staticRenderFns } from "./NotasInseridasFilter.vue?vue&type=template&id=6ee519a3&"
import script from "./NotasInseridasFilter.vue?vue&type=script&lang=ts&"
export * from "./NotasInseridasFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports